import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component, Fragment } from "react";
import TaskTemplateList from "./taskTemplateList";
import Pager from "../../../src/View/UI/Pager/Pager";
import ServiceContainer from "../../shared/ServiceContainer";
import TaskService from "../../../services/TaskService";
import { getTaskAdminTemplateCreatePath } from "../../../src/View/Pages/Admin/Task/TaskTemplate/AdminTaskTemplateRoutes";
export default class TableIndex extends Component {
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.setCurrentPage = this.setCurrentPage.bind(this);
        this.state = {
            page: 1,
            max: 30,
            order: "asc",
            sort: "title",
        };
    }
    // @ts-expect-error - TS7006 - Parameter 'i' implicitly has an 'any' type.
    setCurrentPage(i) {
        this.setState({ page: i + 1 });
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx("content", { tag: "secondaryNavbar", children: _jsx("div", { className: "navbar-secondarynav fixed fit-to-parent border-right", role: "navigation", style: { width: "100%" }, children: _jsxs("a", { href: getTaskAdminTemplateCreatePath(), className: "btn btn-link", title: "new", children: [_jsx("span", { className: "fa fa-plus" }), " New"] }) }) }), _jsxs("div", { className: "container-fluid pb-3 pt-3", children: [_jsx("div", { className: "title-block clearfix", children: _jsx("div", { className: "d-flex justify-content-between", children: _jsx("h1", { className: "title", children: "Task Templates" }) }) }), _jsx("div", { role: "main", children: _jsx(ServiceContainer, { serviceMethod: TaskService.getTaskTemplates, serviceMethodArgs: [
                                    this.state.max,
                                    this.state.page,
                                    this.state.order,
                                    this.state.sort,
                                ], children: (data, isLoading, hasError, errorMessage) => (_jsxs(Fragment, { children: [_jsx(TaskTemplateList, { templates: data && data.templates, isLoading: isLoading, hasError: hasError, errorMessage: errorMessage, setSort: (sort) => {
                                                if (this.state.order === "asc") {
                                                    this.setState({ sort, order: "desc" });
                                                }
                                                else {
                                                    this.setState({ sort, order: "asc" });
                                                }
                                            } }), _jsx(Pager, { currentPage: this.state.page - 1, setCurrentPage: this.setCurrentPage, totalPages: data ? Math.ceil(data.totalCount / this.state.max) : 0 })] })) }) })] })] }));
    }
}
